import type { ResultOf } from '@horof/shared';
import { graphql } from './gql';

/**
 * What a member's or a meter's page adds to its panel (doc 58): messages,
 * reminders, status history, credit movements, replacements.
 */

export const MemberHistoryDocument = graphql(`
  query DeskMemberHistory($id: UUID!) {
    member(id: $id) {
      id
      creditBalance
      whatsappMessages(orderBy: [CREATED_AT_DESC], first: 200) {
        nodes {
          id
          status
          toPhone
          createdAt
          sentAt
          error
          queuedBy
          bill {
            id
            billMonth
          }
        }
      }
      notifications(orderBy: [SENT_AT_DESC], first: 200) {
        nodes {
          id
          kind
          channel
          phone
          sentAt
          sentBy
          amountDue
        }
      }
      memberStatusChanges(orderBy: [CHANGED_AT_DESC]) {
        nodes {
          id
          fromStatus
          toStatus
          reason
          changedOn
          changedBy
        }
      }
      memberCredits(orderBy: [CREATED_AT_DESC]) {
        nodes {
          id
          kind
          amount
          reason
          createdAt
          createdBy
          bill {
            id
            billMonth
          }
        }
      }
    }
  }
`);

export type MemberHistory = NonNullable<
  ResultOf<typeof MemberHistoryDocument>['member']
>;

export const MeterHistoryDocument = graphql(`
  query DeskMeterHistory($id: UUID!) {
    meter(id: $id) {
      id
      meterStatusChanges(orderBy: [CHANGED_AT_DESC]) {
        nodes {
          id
          fromStatus
          toStatus
          reason
          reading
          changedOn
          changedBy
          meterByReplacedBy {
            id
            label
          }
        }
      }
      replaced: metersByReplacedBy {
        nodes {
          id
          label
        }
      }
    }
  }
`);
